import React, { useContext, useEffect, useState } from 'react'
import { ShopifyContext } from '../components/Layout'
import { CountryContext } from '../gatsby/wrap-wroot-element'
import { fetchCurrency } from '../utils/reachLocalize'

function useReachCurrency(variants) {
  const geoState = useContext(CountryContext)
  const [loaded, setLoaded] = useState(false)
  const [presentmentPrices, setPresentmentPrices] = useState(false)
  const { setNotSupportedCountry } = useContext(ShopifyContext)

  const notUs = geoState.country && geoState.country !== 'US'
  useEffect(() => {
    if (notUs) {
      fetchCurrency(
        variants,
        geoState.country,
        setPresentmentPrices,
        setLoaded,
        setNotSupportedCountry
      )
    }
    if (geoState.country === 'US') {
      setLoaded(true)
    }
  }, [geoState])

  const getRegionalCompareAt = index =>
    presentmentPrices &&
    presentmentPrices.ConsumerPrices &&
    presentmentPrices.ConsumerPrices[
      index + presentmentPrices.ConsumerPrices.length / 2
    ]

  const getRegionalPrice = index =>
    presentmentPrices &&
    presentmentPrices.ConsumerPrices &&
    presentmentPrices.ConsumerPrices[index]

  const convertedCurrency = presentmentPrices
    ? presentmentPrices.Currency
    : 'USD'

  return {
    notUs,
    loaded,
    presentmentPrices,
    getRegionalCompareAt,
    getRegionalPrice,
    convertedCurrency,
    ConsumerPrices: presentmentPrices && presentmentPrices.ConsumerPrices,
  }
}

export default useReachCurrency
